import { render, staticRenderFns } from "./MigrateParticipantModal.vue?vue&type=template&id=6555b9f9&"
import script from "./MigrateParticipantModal.vue?vue&type=script&lang=js&"
export * from "./MigrateParticipantModal.vue?vue&type=script&lang=js&"
import style0 from "./MigrateParticipantModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports